/*  Shared  */
import { S3 } from 'application/Shared/Handlers';
import { Response } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { Env, debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

export const getScript = async ({ filename, token }) => {
    const script = await S3.getResource(filename);

    const copyValue = script.replace(
        '%URL%',
        Env.get('REACT_APP_DEPLOYMENT_URL')
    );

    return copyValue.replace('%TOKEN%', token);
};

export const getIntegrationsData = async () => {
    try {
        const requests = new Requests();
        const response = await axios.get('/integrations/config', {
            cancelToken: requests.token()
        });

        if (!Response.has(response)) {
            debug.e('No Integration Config found', response);
            return null;
        }

        const integrations = Response.get(response);
        const { config } = integrations;

        const workflow = [];
        const deployment = [];
        const data = [];
        Object.values(config).forEach((d) => {
            const { type } = d;
            const obj = { ...d, show: true };

            switch (type) {
                case 'workflow': {
                    workflow.push(obj);
                    break;
                }
                case 'data': {
                    data.push(obj);
                    break;
                }
                default: {
                    deployment.push(obj);
                    break;
                }
            }
        });

        return { data, deployment, workflow };
    } catch (e) {
        debug.e('Unable to load Integrations', e);
        return null;
    }
};
